import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import moment from 'moment';
import { Cards } from '../../../components/cards/frame/cards-frame';
import compassImg from '../../../static/img/dashboard/compass.svg';
import { DataService } from '../../../config/dataService/dataService';

const { Option } = Select;
const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

function EmployeeOverview() {
  // Current Month (0 = Jan, 11 = Dec) & Year
  const [selectedMonth, setSelectedMonth] = useState(moment().month());
  const [selectedYear, setSelectedYear] = useState(moment().year());
  const [totalLeadsCount, setTotalLeadsCount] = useState(0);

  // Dynamic Calendar Days Generator
  const generateCalendarDays = () => {
    const startDate = moment([selectedYear, selectedMonth]).startOf('month');
    const daysInMonth = startDate.daysInMonth();

    // ISO weekday (1 = Monday, 7 = Sunday)
    const startDayOfWeek = startDate.isoWeekday() - 1;
    const daysGrid = [];

    // Previous month padding days
    const prevMonthDays = startDate.clone().subtract(1, 'month').daysInMonth();
    for (let i = startDayOfWeek - 1; i >= 0; i--) {
      daysGrid.push({ day: prevMonthDays - i, isCurrentMonth: false });
    }

    // Current month dates
    for (let day = 1; day <= daysInMonth; day++) {
      daysGrid.push({
        day,
        isCurrentMonth: true,
      });
    }

    // Next month padding days to complete 35/42 grid cells
    const totalCells = daysGrid.length > 35 ? 42 : 35;
    const remainingCells = totalCells - daysGrid.length;
    for (let day = 1; day <= remainingCells; day++) {
      daysGrid.push({ day, isCurrentMonth: false });
    }

    return daysGrid;
  };

  const daysGrid = generateCalendarDays();
  const monthsList = moment.months(); // ["January", "February", ..., "December"]
  const yearsList = [2024, 2025, 2026, 2027, 2028];

  useEffect(() => {
    const fetchTotalLeads = async () => {
      try {
        const response = await DataService.get('/students?page=1&limit=1');
        const count = response?.data?.data?.count || response?.data?.count || 0;
        setTotalLeadsCount(count);
      } catch (error) {
        console.error('Error fetching total leads count:', error);
      }
    };
    fetchTotalLeads();
  }, []);

  return (
    <div className="monthly-attendance-container">
      <Cards
        title={
          <div className="monthly-attendance-title">
            <span style={{ fontSize: '14px', fontWeight: '600' }}>
              MONTHLY ATTENDANCE - {monthsList[selectedMonth]} {selectedYear}
            </span>
          </div>
        }
        headless={false}
        border={true}
        className="overview-custom-card"
      >
        <div className="month-year-select">
          <Select value={selectedMonth} onChange={(val) => setSelectedMonth(val)} size="small">
            {monthsList.map((month, idx) => (
              <Option key={idx} value={idx}>
                {month}
              </Option>
            ))}
          </Select>
          <Select value={selectedYear} onChange={(val) => setSelectedYear(val)} size="small">
            {yearsList.map((year) => (
              <Option key={year} value={year}>
                {year}
              </Option>
            ))}
          </Select>
        </div>
        <div className="weekdays-grid">
          {daysOfWeek.map((day) => (
            <span key={day} className="weekday-label">
              {day}
            </span>
          ))}
        </div>

        <div className="days-grid">
          {daysGrid.map((item, index) => (
            <div
              key={index}
              className={`day-circle ${
                item.isCurrentMonth ? 'default-day' : 'default-day opacity-muted'
              }`}
              style={{ opacity: item.isCurrentMonth ? 1 : 0.3 }}
            >
              {item.day}
            </div>
          ))}
        </div>
      </Cards>

      <div className="leads-count-card">
        <div className="card-title">TOTAL LEADS COUNT</div>
        <div className="card-body">
          <div className="compass-icon">
            <img src={compassImg} alt="Compass" />
          </div>
          <div className="count-value">{totalLeadsCount.toLocaleString()}</div>
        </div>
      </div>
    </div>
  );
}

export default EmployeeOverview;
